<template>
  <div style="margin-top: 40px">
    <GroupProccess :selectedItems="selected_requests" @filterData="handleFilter" :selectedTab="selectedTab" />

    <template>
     <v-row>
      <v-col cols="12" sm="7" md="7">
        <!-- <v-tabs v-model="selectedTab" style="margin-bottom: 50px;" class="custom-tabs-center-1">
          <div class="custom-tab-wrapper" :style="{ backgroundColor: selectedTab === 0 ? '#3f0e40' : ''}">
            <v-tab :key="0" @click="tabsFilter(0)" class="custom-tab">الكل</v-tab>
          </div>
          <div class="custom-tab-wrapper" :style="{ backgroundColor: selectedTab === 1 ? '#3f0e40' : ''}">
            <v-tab :key="1" @click="tabsFilter(1)" class="custom-tab">لم يعالجه م المبيعات</v-tab>
          </div>
          <div class="custom-tab-wrapper" :style="{ backgroundColor: selectedTab === 2 ? '#3f0e40' : ''}">
            <v-tab :key="2" @click="tabsFilter(2)" class="custom-tab">عالجه م المبيعات</v-tab>
          </div>
          <div class="custom-tab-wrapper" :style="{ backgroundColor: selectedTab === 3 ? '#3f0e40' : ''}">
            <v-tab :key="3" @click="tabsFilter(3)" class="custom-tab">عالجه الادمن</v-tab>
          </div>
        </v-tabs> -->



        <div  style="display: flex;margin-bottom: 21px;" class="rates">

          <div class="text-center right_bouttons " style="position: relative">
            <v-btn
              class="ma-2 white--text filter__border"
        
         :style="{
            'background-color': selectedTab === 1  ? '#3F0E40' : ($store.getters.isDark ? '#424242' : '#D2C8D4'),
          }"
              @click="tabsFilter(1)"
            >
              <span :style="{ color: selectedTab === 1 ? 'white' : 'white' }">
                لم يعالجه م المبيعات
              </span>
              <div :class="[selectedTab === 1 && switchColor.notProccessedFromSalesManager ? 'down__arrow' : '']"></div>
            </v-btn>
          </div>


          <div class="text-center right_bouttons" style="position: relative">
            <v-btn
              class="ma-2 white--text filter__border"
              :style="{
                'background-color': selectedTab === 2  ? '#3F0E40' : ($store.getters.isDark ? '#424242' : '#D2C8D4'),
              }"
              @click="tabsFilter(2)"
            >
              <span :style="{ color: selectedTab === 2 ? 'white' : 'white' }">
              
                عالجه م المبيعات
              </span>
              <div :class="[selectedTab === 2 && switchColor.ProccessedFromSalesManager ? 'down__arrow' : '']"></div>
            </v-btn>
          </div>

          <div class="text-center right_bouttons" style="position: relative">
            <v-btn
              class="ma-2 white--text filter__border"
              :style="{
                'background-color': selectedTab === 3 ? '#3F0E40' : ($store.getters.isDark ? '#424242' : '#D2C8D4'),
              }"
              @click="tabsFilter(3)"
            >
              <span :style="{ color: selectedTab === 3 ? 'white' : 'white' }">
                عالجه الادمن
              </span>
              <div :class="[selectedTab === 3 && switchColor.ProccessedFromAdmin ? 'down__arrow' : '']"></div>
            </v-btn>
          </div>

          <div class="text-center right_bouttons" style="position: relative">
            <v-btn
              class="ma-2 white--text filter__border"
              :style="{
                'background-color': selectedTab === 0  ? '#3F0E40' : ($store.getters.isDark ? '#424242' : '#D2C8D4'),
              }"
              @click="tabsFilter(0)"
            >
              <span :style="{ color: selectedTab === 0 ? 'white' : 'white' }">
                الكل
              </span>
              <div :class="[selectedTab === 0 && switchColor.getAllRates ? 'down__arrow' : '']"></div>
            </v-btn>
          </div>

        </div>


      </v-col>

      <v-col cols="12" sm="3" md="3" class="offset-sm-2 offset-md-2">
        <div style="display: flex;">
          <v-tabs class="custom-tabs-center-2">
            <div style="margin: 10px; text-align: center;">
              <v-rating
                v-model="number_of_stars"
                active-color="yellow"
                @click="handleStarsFilter"
                color="#F2C94C"
                density="compact"
                size="large"
              ></v-rating>
            </div>
          </v-tabs>
        </div>
      </v-col>
     </v-row>
    </template>

    <new-table-component
      :showSelect="true"
      itemKey="id"
      :selectedRows.sync="selected_requests"
      :headers="getHeaders"
      :pagination="pagination"
      :limit="$store.state.counterOfShow"
      :items="tableData"
      :loading="loading"
      v-model="page"
    >
      <template slot="item.stars" slot-scope="props">
        <div class="text-center">
          <v-rating
            v-model="props.item.stars"
            bg-color="orange-lighten-1"
            color="yellow"
            readonly
          ></v-rating>
        </div>
      </template>


      <template slot="item.customer" slot-scope="props">
        <span v-if="!props.item.customer"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.customer.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.customer }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.agent" slot-scope="props">
        <span v-if="!props.item.agent"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.agent.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.agent }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.agent_notes" slot-scope="props">
        <span v-if="!props.item.request?.comment"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.request?.comment.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request?.comment }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.comments" slot-scope="props">
        <span v-if="!props.item.comments"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.comments.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.comments }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.sales_notes" slot-scope="props">
        <span v-if="!props.item.notes"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.notes.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.notes }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.source" slot-scope="props">
        <span v-if="!props.item.source"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
              props.item.source.substring(0, 10) + "..."
            }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.source }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.is_processed_by_sales_manager" slot-scope="props">
        <div :style="{ color: isProccessedBySalesManager(props.item.is_processed) == 'نعم' ? 'green' : 'red' }">
          {{ isProccessedBySalesManager(props.item.is_processed) }}
        </div>
      </template>

      <template slot="item.is_processed_by_admin" slot-scope="props">
        <div :style="{ color: isProccessedByAdmin(props.item.is_processed) == 'نعم' ? 'green' : 'red' }">
          {{ isProccessedByAdmin(props.item.is_processed) }}
        </div>
      </template>

      <template slot="item.rate_date" slot-scope="props">
        <div>
          <div>{{ props.item.rate_date.split(' ')[0] }}</div> <!-- Display date -->
          <div>{{ extractTime(props.item.rate_date) }}</div> <!-- Display time -->
        </div>
      </template>


      <template slot="item.agent_classification" slot-scope="props">
        <div :style="{ color: props.item.request?.class_id_agent_text == 'تعذر الإتصال' ? 'red' : '' }">
          {{ props.item.request?.class_id_agent_text }}
        </div>
      </template>

    

      <template slot="item.notes" slot-scope="props" v-if="props.item.is_processed != 0">
        <div>
          {{ props.item.notes }}
        </div>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#3F0E40" small depressed dark v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <SingleProcess :item="item['request_id']" :idOfRate="item['id']" :rateRecord="item" @refreshAfterProccesses="refreshDataAfterProccesses"/>
          </v-list>
        </v-menu>
      </template>
    </new-table-component>
    <OrderRequestSection
      v-if="this.$store.state.openOrderRequestSection"
      style="margin-top: 50px"
    />

    <TasksRequestSection
      v-if="this.$store.state.openTasksRequestSection"
      style="margin-top: 50px"
    />

    <AddTaskForRequest
      v-if="this.$store.state.openAddTaskForRequest"
      style="margin-top: 50px"
    />

    <TasksDetailsRequestSection
      v-if="this.$store.state.openTasksDetailsRequestSection"
      style="margin-top: 50px"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount,computed } from "vue";
import { axiosInstance } from "@/axios/config";
import SingleProcess from "./SingleProcess.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import TasksRequestSection from "@/components/AdminComponent/TasksRequestSection.vue";
import AddTaskForRequest from "@/components/AdminComponent/AddTaskForRequest.vue";
import TasksDetailsRequestSection from "@/components/AdminComponent/TasksDetailsRequestSection.vue";
import GroupProccess from "@/views/admin/ServiceRate/GroupProccess.vue";
import { store } from "@/store";
import { color } from "highcharts";

let loading = ref(false);
const headers = [
  { text: "تاريخ التقيم", value: "rate_date",align: "center",},
  { text: "الاسم", value: "customer",align: "center" },
  { text: "استشاري المبيعات", value: "agent",align: "center" },
  { text: "تصنيف الطلب", value: "agent_classification",align: "center" },
  { text: "ملاحظة الاستشاري", value: "agent_notes",align: "center" },
  // { text: "الجوال", value: "mobile" },
  { text: "التقييم", value: "stars", align: "center" },
  { text: "التعليق", value: "comments", width: "100px",align: "center" },
  { text: "عالجه م.المبيعات", value: "is_processed_by_sales_manager",align: "center" },
  { text: " عالجه الادمن", value: "is_processed_by_admin",align: "center" },
  { text: "تعقيب م.مبيعات", value: "sales_notes",align: "center" },
  { text: "مصدر التقييم", value: "source",align: "center" },
  { text: "العمليات", value: "action",align: "center" },
];

const switchColor = ref({
  getAllRates: true,
  notProccessedFromSalesManager: false,
  ProccessedFromSalesManager: false,
  ProccessedFromAdmin: false,
});
const isDark = computed(() => store.getters.isDark); // Use store getter for isDark
console.log(isDark.value)

const page = ref(1);
const number_of_stars = ref(null);
const filterData = ref({});

watch(page, (current) => {
  getData(current, filterData.value);
});

watch(() => store.state.counterOfShow,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      getData(page.value)
    }
  }
);
console.log(isDark.value)
watch(number_of_stars, (newVal) => {
  handleStarsFilter(newVal);
});

const getHeaders = computed(() => {
  if (selectedTab.value === 3) {
    return headers.filter(header => header.value !== "is_processed_by_admin" && header.value !== "is_processed_by_sales_manager");
  } else if (selectedTab.value === 1) {
    return headers.filter(header => header.value !== "is_processed_by_admin" && header.value !== "is_processed_by_sales_manager");
  } else if (selectedTab.value === 2) {
    return headers.filter(header => header.value !== "is_processed_by_sales_manager");
  } else {
    return headers;
  }
});

const handleFilter = (data) => {
  filterData.value = data;
  tableData.value = [];
  page.value = 1;
  getData(1, data);
};


const handleStarsFilter = (stars) => {
  filterData.value.stars = stars;
  getData(page.value, filterData.value);
};

const pagination = ref({});
const tableData = ref([]);
let selectedTab = ref(0);


const getData = (count, data) => {
  console.log(selectedTab)
  loading.value = true;

  let body = new FormData();
  body.append("page", count);

  if (data) {
    for (const key in data) {
      if (data[key] !== "" && data[key] !== undefined && data[key] !== null) {
        body.append(key, data[key]);
      }
    }
  }

  if(selectedTab.value == 0){
    switchColor.value.getAllRates = true;
    body.delete(`is_processed`);
  }
  
  if(selectedTab.value == 1){
    switchColor.value.notProccessedFromSalesManager = true;
    body.append(`is_processed`,0);
  }

  if(selectedTab.value == 2){
    switchColor.value.ProccessedFromSalesManager = true;
    body.append(`is_processed`,1);
  }

  if(selectedTab.value == 3){
    switchColor.value.ProccessedFromAdmin = true;
    body.append(`is_processed`,2);
  }

  axiosInstance
    .post(`/employee/admin/rate-services?per_page=${store.state.counterOfShow}`, body)
    .then((res) => {
      const response = res.data.payload;
      tableData.value = response.data;
      let paginationCount = null;
      // if (data) {
      //   paginationCount = response.searched_count;
      // } else {
      //   paginationCount = response.total_count;
      // }

      paginationCount = response.searched_count;
      pagination.value = {
        limit: 3,
        count: paginationCount,
      };
      loading.value = false;
    })
    .catch((err) => (loading.value = false));
};

const isProccessedBySalesManager = (status) => {
  return status != 0 ? `نعم` : `لا`;
};

const isProccessedByAdmin = (status) => {
  return status == 2 ? `نعم` : `لا`;
};

const extractTime = (rateDate) => {
  // Regular expression to match the time part
  const timeRegex = /\d{2}:\d{2} [AP]M/;
  // Extract the time part using regex
  const timeMatch = rateDate.match(timeRegex);
  // If match found, return the time part
  return timeMatch ? timeMatch[0] : '';
};



const tabsFilter = (value) => {
  selectedTab.value = value;
  getData(page.value,filterData.value)
};


const refreshDataAfterProccesses = () => {
  getData(page.value,filterData.value)
};

onBeforeUnmount(() => {
  store.state.openOrderRequestSection = false;
});

let selected_requests = ref([]);

onMounted(() => {
  getData(1);
});
</script>

<style scoped>
.custom-tabs {
  border-bottom: 1px solid #ccc; 
}

.custom-tab {
  color: white; 
  font-weight: bold;
  transition: background-color 0.3s ease; 
}

.custom-tab:hover {
  color: white;
}

.custom-tab-wrapper {
  background-color: #e3dce3;
  padding: 10px;
  margin: 5px;
  border-radius: 5px;
}

.custom-tabs-center-1 {
  display: flex !important;
  justify-content: right !important;
}

.custom-tabs-center-2 {
  display: flex !important;
  justify-content: left !important;
}

.down__arrow {
  position: absolute;
  bottom: -19px;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
          border-top: 8px solid var(--primary-color);
  transform: translateX(-50%);
}

</style>
